import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import client from "../api/client";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await client.post("/forgot-password", { email });
      navigate("/login", { state: { message: "If you have an account, the password reset email was sent! Check your inbox." } });
    /*} catch (err) {
      navigate("/login", { state: { message: "If an account exists with that email, a reset link has been sent." } });
    } */
    } catch (err) {
  console.error('Forgot password error:', err.response?.status, err.response?.data);
  setError(JSON.stringify(err.response?.data) || err.message);
  setIsSubmitting(false);
}
   finally {
      setIsSubmitting(false);
    }
  };

 

  return (
    <main className="AuthPage" style={{ maxWidth: "480px", margin: "0 auto" }}>
      <h1>Forgot Password</h1>
      <p style={{ opacity: 0.85, marginBottom: "24px" }}>
        Enter your email address and we'll send you a link to reset your password.
      </p>

      {error && <p className="error">{error}</p>}

      <form onSubmit={handleSubmit}>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Send Reset Link"}
        </button>
      </form>

      <p style={{ marginTop: "16px" }}>
        <Link to="/login">← Back to Log In</Link>
      </p>
    </main>
  );
}

export default ForgotPasswordPage;